import { FC } from 'react';
import LinkIcon from '@mui/icons-material/Link';

const LinkInfo: FC = () => (
  <LinkIcon
    color="info"
    sx={{
      fontSize: '26px',
      marginRight: '.2em',
      marginTop: '2px',
      color: '#266DCC',
    }}
  />
);

export default LinkInfo;
